export const EDD_TABS = [
  { key: "PROCUREMENT_SLA", label: "Procurement SLA" },
  { key: "INVENTORY_LEAD_TIME", label: "Vendor SLA" },
  { key: "SERVICE_CENTRE_SLA", label: "Service Centre SLA" },
  { key: "ORDER_PROCESSING_SLA", label: "Order Processing SLA" },
  { key: "VENDOR_WORKING_HOURS", label: "Vendor Working Hours" },
  { key: "VENDOR_OFF_DAYS", label: "Vendor Off Days" },
];

export const EDD_TEMPLATE_NAMES = {
  PROCUREMENT_SLA: "sample_procurement_sla_template",
  INVENTORY_LEAD_TIME: "sample_inventory_lead_time_template",
  ORDER_PROCESSING_SLA: "sample_order_processing_sla_template",
  SERVICE_CENTRE_SLA: "sample_service_centre_sla_template",
  VENDOR_WORKING_HOURS: "sample_add_vendor_working_hours_template",
  VENDOR_OFF_DAYS: "sample_add_vendor_Off_days_template",
};

export const SLA_UPLOAD_CONFIGS = {
  PROCUREMENT_SLA: {
    key: "PROCUREMENT_SLA",
    title: "Procurement SLA",
    description:
      "Vendor-side lead time (hours) for sourcing a given material. Four-level precedence — most specific match wins.",
    badges: [
      { label: "T1S", variant: "info" },
      { label: "DISTRIBUTOR", variant: "purple" },
    ],
    tableCode: "inventory.procurement_sla",
    dropzoneSubtext:
      "Header row required · one row per vendor + match-key combination",
    actionLabel: "View sample",
    templateFileName: "procurement_sla_template.csv",
    templateHeaders: [
      "vendor_id",
      "category_key",
      "product_key",
      "brand",
      "sub_brand",
      "grade",
      "sub_grade",
      "thickness",
      "width",
      "length",
      "diameter",
      "cut_length",
      "tmt_form",
      "lead_time",
      "status",
    ],
    expectedColumns: [
      { name: "vendor_id", type: "Text (String)", req: "REQ" },
      { name: "category_key", type: "Number", req: "REQ" },
      { name: "product_key", type: "Number", req: "OPT" },
      { name: "brand", type: "Text (String)", req: "OPT" },
      { name: "sub_brand", type: "Text (String)", req: "OPT" },
      { name: "grade", type: "Text (String)", req: "OPT" },
      { name: "sub_grade", type: "Text (String)", req: "OPT" },
      { name: "thickness", type: "Number", req: "OPT" },
      { name: "width", type: "Number", req: "OPT" },
      { name: "length", type: "Number", req: "OPT" },
      { name: "diameter", type: "Number", req: "OPT" },
      { name: "cut_length", type: "Number", req: "OPT" },
      { name: "tmt_form", type: "Text (String)", req: "OPT" },
      { name: "lead_time", type: "Number", req: "REQ" },
      { name: "status", type: "Text (String)", req: "REQ" },
    ],
    callout: {
      label: "Abbreviation",
      text: "REQ -> REQUIRED · OPT -> OPTIONAL",
    },
    sampleData: [
      {
        vendor_id: "VEND_1001",
        category_key: "12",
        product_key: "450",
        brand: "JSW Steel",
        sub_brand: "Neosteel",
        grade: "Fe550D",
        sub_grade: "Standard",
        thickness: "12.00",
        width: "1250.00",
        length: "12.00",
        diameter: "12.00",
        cut_length: "",
        tmt_form: "Straight",
        lead_time: "48.00",
        status: "ACTIVE",
      },
      {
        vendor_id: "VEND_1002",
        category_key: "12",
        product_key: "",
        brand: "JSW Steel",
        sub_brand: "",
        grade: "",
        sub_grade: "",
        thickness: "",
        width: "",
        length: "",
        diameter: "",
        cut_length: "",
        tmt_form: "",
        lead_time: "72.00",
        status: "ACTIVE",
      },
    ],
  },

  INVENTORY_LEAD_TIME: {
    key: "INVENTORY_LEAD_TIME",
    title: "Vendor SLA",
    description:
      "Plant-side quantity-bucketed lead time. PHYSICAL rows are always 0h (on-hand); PLANNED & SLA rows carry positive hours.",
    badges: [{ label: "PLANT (MTS / MTO)", variant: "teal" }],
    tableCode: "inventory.inventory_lead_time",
    dropzoneSubtext:
      "One row per (vendor, mmid, uom, inventory_type) bucket",
    actionLabel: "View sample",
    templateFileName: "inventory_lead_time_template.csv",
    templateHeaders: [
      "vendor_id",
      "mmid",
      "qty",
      "uom",
      "inventory_type",
      "lead_time_hours",
      "status",
    ],
    expectedColumns: [
      { name: "vendor_id", type: "Text (String)", req: "REQ" },
      { name: "mmid", type: "Text (String)", req: "OPT" },
      { name: "qty", type: "Number", req: "REQ" },
      { name: "uom", type: "Text (String)", req: "REQ" },
      {
        name: "inventory_type",
        type: "PHYSICAL · PLANNED · SLA",
        req: "REQ",
      },
      { name: "lead_time_hours", type: "Number", req: "REQ" },
      { name: "status", type: "ACTIVE · INACTIVE", req: "REQ" },
    ],
    callout: {
      label: "Abbreviation",
      text: "REQ -> REQUIRED · OPT -> OPTIONAL",
    },
    sampleData: [
      {
        vendor_id: "PLANT_VIJAYANAGAR",
        mmid: "1000-10000-1001",
        qty: "50.000",
        uom: "MT",
        inventory_type: "PHYSICAL",
        lead_time_hours: "0.00",
        status: "ACTIVE",
      },
      {
        vendor_id: "PLANT_VIJAYANAGAR",
        mmid: "1000-10000-1001",
        qty: "200.000",
        uom: "MT",
        inventory_type: "PLANNED",
        lead_time_hours: "24.00",
        status: "ACTIVE",
      },
      {
        vendor_id: "PLANT_DOLVI",
        mmid: "",
        qty: "500.000",
        uom: "MT",
        inventory_type: "SLA",
        lead_time_hours: "48.00",
        status: "ACTIVE",
      },
    ],
  },

  SERVICE_CENTRE_SLA: {
    key: "SERVICE_CENTRE_SLA",
    title: "Service Centre SLA",
    description:
      "Overall service-centre processing hours per (vendor, category). T1S vendors only. Additional per-step columns in CSV are preserved but not consumed by the engine (MVP).",
    badges: [{ label: "T1S only", variant: "blue" }],
    tableCode: "inventory.service_centre_sla",
    dropzoneSubtext:
      "One row per (vendor_location_key, category_key)",
    actionLabel: "View sample",
    templateFileName: "service_centre_sla_template.csv",
    templateHeaders: [
      "vendor_id",
      "category_key",
      "overall_sla",
      "status",
      "order_to_slot",
      "slot_to_processing",
      "qc_hours",
      "packaging_hours",
    ],
    expectedColumns: [
      { name: "vendor_id", type: "Text (String)", req: "REQ" },
      { name: "category_key", type: "Text (String)", req: "REQ" },
      {
        name: "overall_sla",
        type: "Number · hours",
        req: "REQ",
      },
      { name: "status", type: "ACTIVE · INACTIVE", req: "REQ" },
      { name: "order_to_slot", type: "Number", req: "OPT" },
      { name: "slot_to_processing", type: "Number", req: "OPT" },
      { name: "qc_hours", type: "Number", req: "OPT" },
      { name: "packaging_hours", type: "Number", req: "OPT" },
    ],
    callout: {
      label: "Abbreviation",
      text: "REQ -> REQUIRED · OPT -> OPTIONAL",
    },
    sampleData: [
      {
        vendor_id: "VLOC_PUNE_01",
        category_key: "COILS_SHEETS",
        overall_sla: "18.50",
        status: "ACTIVE",
        order_to_slot: "2.00",
        slot_to_processing: "8.00",
        qc_hours: "4.00",
        packaging_hours: "4.50",
      },
      {
        vendor_id: "VLOC_BLR_02",
        category_key: "TMT_REBARS",
        overall_sla: "12.00",
        status: "ACTIVE",
        order_to_slot: "1.00",
        slot_to_processing: "6.00",
        qc_hours: "2.00",
        packaging_hours: "3.00",
      },
    ],
  },

  ORDER_PROCESSING_SLA: {
    key: "ORDER_PROCESSING_SLA",
    title: "Order Processing SLA",
    description:
      "Internal processing legs — DO release, vehicle assignment, loading, invoicing, etc. One row per leg; engine sums all ACTIVE rows into a single leg with per-row subLegs on the response.",
    badges: [{ label: "Applies to every order", variant: "default" }],
    tableCode: "inventory.order_processing_sla",
    dropzoneSubtext: "Full set of legs — typically 10–15 rows",
    actionLabel: null,
    templateFileName: "order_processing_sla_template.csv",
    templateHeaders: ["sequence", "sla_leg", "sla_hours", "status"],
    expectedColumns: [
      { name: "sequence", type: "Number > 0", req: "REQ" },
      {
        name: "sla_leg",
        type: "Text (String) · UNIQUE active",
        req: "REQ",
      },
      { name: "sla_hours", type: "Number · ≥ 0", req: "REQ" },
      { name: "status", type: "ACTIVE · INACTIVE", req: "REQ" },
    ],
    callout: {
      label: "Abbreviation",
      text: "REQ -> REQUIRED · OPT -> OPTIONAL",
    },
    sampleData: [
      {
        sequence: 1,
        sla_leg: "DO_RELEASE",
        sla_hours: "2.00",
        status: "ACTIVE",
      },
      {
        sequence: 2,
        sla_leg: "VEHICLE_ASSIGNMENT",
        sla_hours: "4.00",
        status: "ACTIVE",
      },
      {
        sequence: 3,
        sla_leg: "BAY_SCHEDULING",
        sla_hours: "2.50",
        status: "ACTIVE",
      },
      {
        sequence: 4,
        sla_leg: "LOADING_AND_WEIGHING",
        sla_hours: "3.00",
        status: "ACTIVE",
      },
      {
        sequence: 5,
        sla_leg: "INVOICING_AND_GATEPASS",
        sla_hours: "1.50",
        status: "ACTIVE",
      },
    ],
  },
};

export const WEEK_DAYS = [
  { key: "MONDAY", label: "Monday" },
  { key: "TUESDAY", label: "Tuesday" },
  { key: "WEDNESDAY", label: "Wednesday" },
  { key: "THURSDAY", label: "Thursday" },
  { key: "FRIDAY", label: "Friday" },
  { key: "SATURDAY", label: "Saturday" },
  { key: "SUNDAY", label: "Sunday" },
];

export const WEEKLY_SCHEDULE_COLUMNS = [
  { field: "day", headerName: "Day" },
  { field: "start_time", headerName: "Start" },
  { field: "end_time", headerName: "End" },
  { field: "duration", headerName: "Duration" },
  { field: "is_active", headerName: "Active" },
  { field: "action", headerName: "" },
];

export const RECENT_CHANGES_COLUMNS = [
  { field: "changed_by", headerName: "Changed by", minWidth: 150 },
  { field: "changed_at", headerName: "Changed at", minWidth: 150 },
  { field: "change_summary", headerName: "Change summary", minWidth: 250 },
  { field: "status", headerName: "Status", minWidth: 100 },
];

export const EDD_CHANGE_STATUS = {
  APPLIED: "APPLIED",
  PENDING: "PENDING",
  FAILED: "FAILED",
};

export const VENDOR_WORKING_HOURS_TEMPLATE_HEADERS = [
  "day_of_week",
  "start_time",
  "end_time",
  "active",
];

export const UPLOAD_FORMAT_HINT =
  "Date in DD-MM-YYYY format · Time in 24-hour HH:mm format (00:00 to 24:00)";

export const OFF_DAY_WORKING = {
  NO: "NO",
  YES: "YES",
};

export const OFF_DAY_WORKING_OPTIONS = [
  { value: OFF_DAY_WORKING.NO, label: "No — full closure" },
  { value: OFF_DAY_WORKING.YES, label: "Yes — partial closure" },
];

export const OFF_DAYS_COLUMNS = [
  { field: "date", headerName: "Date", minWidth: 120 },
  { field: "day", headerName: "Day", minWidth: 100 },
  { field: "is_working", headerName: "Working?", minWidth: 170 },
  { field: "start_time", headerName: "Start", minWidth: 130 },
  { field: "end_time", headerName: "End", minWidth: 130 },
  { field: "reason", headerName: "Reason", minWidth: 200 },
  { field: "is_active", headerName: "Active" },
  { field: "action", headerName: "" },
];
export const VENDOR_OFF_DAYS_TEMPLATE_HEADERS = [
  "off_date",
  "is_working",
  "start_time",
  "end_time",
  "reason",
  "active",
];
export const WORKING_HOURS_FAILED_ROW_COLUMNS = [
  { field: "dayOfWeek", headerName: "Day" },
  { field: "startTime", headerName: "Start" },
  { field: "endTime", headerName: "End" },
  { field: "active", headerName: "Active" },
  { field: "message", headerName: "Error", minWidth: 250 },
];

export const OFF_DAYS_FAILED_ROW_COLUMNS = [
  { field: "offDate", headerName: "Date", minWidth: 110 },
  { field: "isWorking", headerName: "Working?" },
  { field: "startTime", headerName: "Start" },
  { field: "endTime", headerName: "End" },
  { field: "reason", headerName: "Reason", minWidth: 150 },
  { field: "active", headerName: "Active" },
  { field: "message", headerName: "Error", minWidth: 250 },
];

export const VENDOR_SEARCH_MIN_CHARS = 5;
export const VENDOR_SEARCH_CONTEXT = "VENDOR_ID";
